(() => {
    class RemoveCampaignTargetSourcesModalController {

        constructor(
            $scope,
            $uibModalInstance,
            campaignLevelId,
            proceed,
            cancel
        ) {
            const campaignLevelName = campaignLevelId === Dashboard.Models.Lookups.CampaignLevels.Brand ? "brand" : "store";
            $scope.modalHeading = `Remove ${campaignLevelName} target sources`;

            $scope.confirm = function () {
                $uibModalInstance.close(true);
                proceed();
            };

            $scope.cancel = function () {
                $uibModalInstance.close(false);
                cancel();
            };
        }

    }

    angular
        .module("dashboard")
        .controller("RemoveCampaignTargetSourcesModalController", [
            "$scope",
            "$uibModalInstance",
            "campaignLevelId",
            "proceed",
            "cancel",
            RemoveCampaignTargetSourcesModalController
        ]);
})();
